import { createContext, useContext, useState, useMemo, useRef } from 'react';

const UIContext = createContext({
  appHeaderNavRef: undefined,
  appSubHeaderRef: undefined,
  headerHeight: 0,
  headerHeightMobile: 0,
  mainNetworkHeaderRef: undefined,
  topicMenuHeight: 0,
  setTopicMenuHeight: (_value) => {},
  isNetworkNavVisible: true,
  setIsNetworkNavVisible: (_value) => {},
  isBottomLinksAccordionVisible: true,
  setIsBottomLinksAccordionVisible: (_value) => {},
});

// TODO: Fix the value of headerHeight because its value is not updated when network nav is loaded
// once fixed, reuse this value in
// app/assets/javascripts/react/shared/apps/Topics/containers/TopicShowContainer/components/(TopicHeaderMobile.tsx && TopicHeaderDesktop.tsx)
export const UIProvider = ({ children, headerHeight, headerHeightMobile }) => {
  const mainNetworkHeaderRef = useRef();
  const appSubHeaderRef = useRef();
  const appHeaderNavRef = useRef();
  const [topicMenuHeight, setTopicMenuHeight] = useState();
  const [isNetworkNavVisible, setIsNetworkNavVisible] = useState(true);
  const [isBottomLinksAccordionVisible, setIsBottomLinksAccordionVisible] =
    useState(true);

  const values = useMemo(
    () => ({
      appSubHeaderRef,
      appHeaderNavRef,
      headerHeight,
      headerHeightMobile,
      mainNetworkHeaderRef,
      topicMenuHeight,
      setTopicMenuHeight,
      isNetworkNavVisible,
      setIsNetworkNavVisible,
      isBottomLinksAccordionVisible,
      setIsBottomLinksAccordionVisible,
    }),
    [
      appSubHeaderRef,
      appHeaderNavRef,
      headerHeight,
      headerHeightMobile,
      mainNetworkHeaderRef,
      topicMenuHeight,
      isNetworkNavVisible,
      isBottomLinksAccordionVisible,
    ],
  );

  return <UIContext.Provider value={values}>{children}</UIContext.Provider>;
};

export const useUIContext = () => useContext(UIContext);

export const withUIContext = (Component) => (props) => {
  const contextValue = useUIContext();

  return <Component {...contextValue} {...props} />;
};

export default UIContext;
